<template>
  <div>
    <div v-if="target.length">
      <div v-for="(item, index) in target" :key="index" class="d-flex mb-2">
        <input :type="type" class="form-control mr-2" v-model="target[index]" :required="required">
        <button
          type="button"
          class="btn btn-danger"
          @click="target.splice(index, 1)"
          :disabled="target.length === 1"
        >
          <i class="far fa-trash-alt"></i>
        </button>
      </div>
    </div>
    <div class="text-right">
      <button class="btn btn-primary" type="button" @click="target.push(undefined)">
        <i class="far fa-plus-circle mr-2"></i>
        <span>Add {{addText}}</span>
      </button>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      target: null
    };
  },
  created() {
    this.target = this.value || [undefined];

    if (this.target.length === 0) {
      this.target.push(undefined);
    }
  },
  watch: {
    target() {
      this.$emit("input", this.target.filter(result => result !== undefined));
    }
  },
  props: {
    value: {
      type: Array
    },
    required: {
      type: Boolean,
      default: false
    },
    type: {
      type: String,
      default: "text"
    },
    addText: {
      type: String,
      default: "Item"
    }
  }
};
</script>
